
import React from 'react';
import '../Download/Download.css';


const data = [
  {
    id: 1,
    title: 'B.Tech ECE & ETE 4th Year',
    download: '/Admission Form/_B.Tech ECE & ETE 4th year.pdf',
  },
  {
    id: 2,
    title: 'B.Tech ECE 3rd Year (2021)',
    download: '/Admission Form/4_01-07-2021_15-42-37_B.Tech ECE 3rd year.pdf',
  },
  {
    id: 3,
    title: 'B.Tech 5th and 6th Sem',
    download: '/Admission Form/B.Tech 5th and 6th sem.pdf',
  },
  {
    id: 4,
    title: 'B.Tech CE 7th, 8th Sem G Scheme',
    download: '/Admission Form/B.Tech CE 7th, 8th semG scheme.pdf',
  },
  {
    id: 5,
    title: 'B.Tech EE 4th Year',
    download: '/Admission Form/B.Tech EE 4th year.pdf',
  },
  {
    id: 6,
    title: 'B.Tech EE II Year',
    download: '/Admission Form/B.TECH EE II YEAR.pdf',
  },
  {
    id: 7,
    title: 'B.Tech 1st Year G Scheme Syllabus',
    download: '/Admission Form/B.Tech-1st-Year-G-Scheme-Syllabus-1.pdf',
  },
  {
    id: 8,
    title: 'B.Tech (ECE) 3rd & 4th Sem',
    download: '/Admission Form/B.Tech.(ECE) 3rd & 4th Sem (1).pdf',
  },
  {
    id: 9,
    title: 'B.Tech CSE 4th Year',
    download: '/Admission Form/Bt.Tech_CSE4th-Year.pdf',
  },
  {
    id: 10,
    title: 'B.Tech EE III Year',
    download: '/Admission Form/BTECH EE III YEAR.pdf',
  },
  {
    id: 11,
    title: 'M.Tech Structural Engg. (Syllabus)',
    download: '/Admission Form/M.Tech ( Structural Engg.) 03.02.22 new syllabus.pdf',
  },
  {
    id: 12,
    title: 'M.Tech Computer Science & Engineering',
    download: '/Admission Form/M.Tech (Computer Science & Engineering ).pdf',
  },
  // 
];

const Download = () => {
  return (
     <div className='main-container-download'>
      <div className='container-download-image'>
        {/* <Slide></Slide> */}
      </div>
      <div className='ab1'>
        <div data-aos='flip-left' data-aos-easing='ease-out-cubic' data-aos-duration='2000'>
          <h1 className='ab1-h1'> Syllabus Download  </h1>
          <div className="ab2">
            <table className="ab3">
              <thead>
                <tr>
                  <th>Serial No.</th>
                  <th>Title</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.title}</td>
                    <td>
                      <a
                        href={item.download}
                        download
                        className='ab5'
                      >
                        <span className="ab7">
                          <span className="ab6">Download Now</span>
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
